import * as React from 'react'
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  ReferenceField,
  EditButton,
  DeleteWithConfirmButton,
  TextInput,
  TopToolbar,
  FilterButton,
  ExportButton,
  CreateButton,
  FunctionField,
} from 'react-admin'
import { useTranslate } from 'ra-core'
import { useGetIdentity } from 'react-admin'
import { MyPagination } from '../../MyPagination'
import StatusChip from '../../components/StatusChip'

const FilesFilters = [<TextInput key="cdCampaignId" source="cdCampaignId" />]

const CoregsListActions = () => {
  const translate = useTranslate()
  return (
    <TopToolbar>
      <CreateButton label={translate('surveys.actions.new_coregs')} />
      <FilterButton />
      <ExportButton />
    </TopToolbar>
  )
}

const CoregsList = props => {
  const translate = useTranslate()
  const { identity, loading: identityLoading } = useGetIdentity()
  if (identityLoading) return <>Loading...</>
  const questionSource = 'label.' + identity.country.toLowerCase()
  return (
    <List
      {...props}
      actions={<CoregsListActions />}
      bulkActionButtons={false}
      sort={{ field: 'id', order: 'DESC' }}
      filters={FilesFilters}
      pagination={<MyPagination />}
    >
      <Datagrid>
        <NumberField source="id" sortByOrder="DESC" />
        <ReferenceField
          label={translate('surveys.resources.question')}
          source="questionId"
          reference="questions"
          link="show"
        >
          <TextField source={questionSource} />
        </ReferenceField>
        <TextField label="CD Campaign" source="cdCampaignId" />
        <TextField label="CD Affiliate" source="cdAffiliateId" />
        <FunctionField
          label={translate('surveys.common.status')}
          render={record => (
            <StatusChip
              value={record.status}
              activeLabel={translate('surveys.common.active')}
              inactiveLabel={translate('surveys.common.desactive')}
            />
          )}
        />
        <EditButton />
        <DeleteWithConfirmButton cancel="Cancel" undoable={true} />
      </Datagrid>
    </List>
  )
}

export default CoregsList
